import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';
import { IndividualRenewalService } from '../individual-renewal.service';
import { Subscription } from 'rxjs';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { SubmitQuestionnaireAnswersRequestModel } from '../../../model/submitQuestionnaireAnswersRequestModel';
import { MessageModel } from '../../../model/models';
import { QuestionnaireAnswerModel } from '../../../model/questionnaireAnswerModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import * as $ from 'jquery';
import { EntityRenewalService } from '../../entity-renewal/entity-renewal.service';

@Component({
  selector: 'app-individual-verify-questionnaire',
  templateUrl: './individual-verify-questionnaire.component.html',
  styleUrls: ['./individual-verify-questionnaire.component.css']
})
export class IndividualVerifyQuestionnaireComponent implements OnInit, OnDestroy {

  notifyQuestionListSubscription = new Subscription();
  questions: Array<QuestionnaireQuestionModel> = [];
  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  notifyInactiveOfficesToRenewRequestSubscription = new Subscription();
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = new SelectInactiveOfficesToRenewResponseModel();
  submitQuestionnaireAnswersRequestModel: SubmitQuestionnaireAnswersRequestModel = new SubmitQuestionnaireAnswersRequestModel();
  agree: boolean = false;
  userMessages: Array<MessageModel> = [];

  constructor(private individualRenewalService: IndividualRenewalService,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,
    private router: Router,
    private entityRenewalService : EntityRenewalService) {

          this.questions = this.individualRenewalService.questionnaireQuestionModel;

          this.currentPageWatcher.displayUserMessage = true;

     
     }
  

     ngOnInit() {

       this.startFunction = this.storage.getStartFunctionData();

       this.workflow = this.startFunction.Workflow;

       this.submitQuestionnaireAnswersRequestModel.WorkflowID = this.workflow.WorkflowID;
       this.submitQuestionnaireAnswersRequestModel.CurrentStepIndex = this.workflow.CurrentStepIndex
    }
     
     continue() {
      this.currentPageWatcher.clearUserMessage();
      if (this.agree == false) {
        let userMessage: MessageModel = {};
        userMessage.Alert = 3;
        userMessage.Description = "You must check the box below to continue.";
        this.userMessages.push(userMessage);
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        this.userMessages = [];
      }
  
      else {
  
        this.submitQuestionnaireAnswersRequestModel.Answers=this.questions.map(it => {
          let q = new QuestionnaireAnswerModel();
          q.Answer=it.Answer;
          q.QuestionID=it.QuestionID
          return q;
        });
        this.individualRenewalService.submitIndividualQuestionnaire(this.submitQuestionnaireAnswersRequestModel).subscribe
        ((response : SubmitQuestionnaireAnswersResponseModel)=>{
  
          console.log("submit question response : ", response);
          response.UserMessages.forEach(el => this.userMessages.push(el));
          this.currentPageWatcher.sendUserMessages(this.userMessages);
          if (response.Summary == 0) {
          this.entityRenewalService.renewalWorkflowModel = response.Workflow;
            //save startFunction with updated workflow in localstorage
            this.startFunction.Workflow.CurrentStepIndex = (this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex ? this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex : null);
            this.startFunction.Workflow.WorkflowID = (this.entityRenewalService.renewalWorkflowModel.WorkflowID ? this.entityRenewalService.renewalWorkflowModel.WorkflowID : null);
            this.startFunction.Workflow.WorkflowDisplayName = (this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName ? this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName : null);
            this.startFunction.Workflow.Fees = (this.entityRenewalService.renewalWorkflowModel.Fees ? this.entityRenewalService.renewalWorkflowModel.Fees : null);
            for (let i = 0; i < this.entityRenewalService.renewalWorkflowModel.Steps.length; i++) {
              this.startFunction.Workflow.Steps[i].StepDisplayName = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepDisplayName;
              this.startFunction.Workflow.Steps[i].StepMessage = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepMessage;
              this.startFunction.Workflow.Steps[i].WorkflowStepStatus = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepStatus;
              this.startFunction.Workflow.Steps[i].WorkflowStepType = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepType;

            }
            this.storage.setStartFunctionData(this.startFunction);
            if ((this.startFunction.Workflow.Steps[response.Workflow.CurrentStepIndex]).StepDisplayName.toLowerCase().includes("review")) {
              //redirect to review
              this.router.navigate(["/reviewEntityRenewal"]).then(() => {
                this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
                this.startFunctionService.getNotifyStepInProgress().emit(true);
                this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(response);
              })
              this.userMessages = [];
            }

            if ((this.startFunction.Workflow.Steps[response.Workflow.CurrentStepIndex]).StepDisplayName.toLowerCase().includes("corporation")) {
              //redirect to individual corporation
              this.router.navigate(["/individualCorporation"]).then(() => {
                this.startFunctionService.getNotifyStepInProgress().emit(true);
                this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(response);
                this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
              })
              this.userMessages = [];
            }

            if ((this.startFunction.Workflow.Steps[response.Workflow.CurrentStepIndex]).StepDisplayName.toLowerCase().includes("offices")) {
              //redirect to inactive offices
              this.router.navigate(["/inactiveOfficesToRenew"]).then(() => {
                this.startFunctionService.getNotifyStepInProgress().emit(true);
                this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(response);
                this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
              })
              this.userMessages = [];
            }

            if ((this.workflow.Steps[response.Workflow.CurrentStepIndex]).WorkflowStepType == 53) {
              this.router.navigate(["/entityRenewalQuestionnaire"]).then(() => {
                //add emitters for selected elements in Inactive Offices
                this.startFunctionService.sendStartFunctionBrokerResp(this.startFunction);
                this.startFunctionService.getNotifyStepInProgress().emit(true);
                this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.questions);
                this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(response);
  
              });
              this.userMessages = [];
            }
          }
         
          if (response.Summary == 1) {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            this.userMessages = [];
          }
          if (response.Summary == 2) {
            this.currentPageWatcher.displayUserMessage = true;
            this.router.navigate(["/home"]);
            this.userMessages = [];
          }
        })
      }
    }
  
    goBack() {
      this.router.navigate(["/questionnaireIndividualRenewal"]).then(() => {
        this.currentPageWatcher.clearUserMessage();
        this.startFunctionService.getNotifyStepInProgress().emit(false);
      });
    }
  
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
     this.goBack();
    }

    ngOnDestroy(): void {
      if (this.currentPageWatcher.displayUserMessage == false) {
        this.currentPageWatcher.clearUserMessage();
      }
      this.notifyQuestionListSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/renewal/individual-renewal/individual-verify-questionnaire/individual-verify-questionnaire.component.ts